import { http, setFormData } from '@/utils/http'
import { STATE_FETCH, STATE_CREATE, STATE_UPDATE } from '@/store/actions/state'

const state = {
  states: []
}

const getters = {
  states: state => state.states,
  statesAsOptions: state => {
    let activeStates = state.states.filter(state => state.status === 'active')
    activeStates = activeStates.sort((a, b) => {
      if (a.name < b.name) return -1
      if (a.name > b.name) return 1
      return 0
    })
    return activeStates.map(
      state => ({ text: state.name, value: state._id })
    )
  },
  stateName: storeState => (id) => { // get state name by id
    const state = storeState.states.find(state => state._id === id)
    return state !== undefined ? state.name : ''
  } 
}

const mutations = {
  [STATE_FETCH]: (state, payload) => {
    state.states = [ ...payload ]
  },
  [STATE_UPDATE]: (state, payload) => {
    const updatedStates = [...state.states]
    const oldStateIndex = updatedStates.findIndex(
      state => (state._id === payload._id)
    )
    updatedStates[oldStateIndex] = Object.assign(updatedStates[oldStateIndex], payload)
    state.states = updatedStates
  }
}

const actions = {
  [STATE_FETCH]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      http.get('state/read_all')
        .then(({ data: response }) => {
          if (response.code === 200) {
            commit(STATE_FETCH, response.data)
            resolve(response)
          }
          else {
            reject(response)
          }
        })
    })
  },
  [STATE_CREATE]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      const params = setFormData(payload)
      http.post('state/create', params)
        .then(({ data: response }) => {
          if (response.code === 200) {
            resolve(response)
          }
          else {
            reject(response)
          }
        })
    })
  },
  [STATE_UPDATE]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      const params = setFormData(payload)
      http.post('state/update', params)
        .then(({ data: response }) => {
          if (response.code === 200) {
            commit(STATE_UPDATE, payload)
            resolve(response)
          }
          else {
            reject(response)
          }
        })
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
